import {Provider} from "@angular/core"
import {LoggerFactory} from "@app/common/services/logging/logger-factory.service"
import {
    CM_LOGGER_API,
    CM_LOGGER_APP,
    CM_LOGGER_AR,
    CM_LOGGER_AUTH,
    CM_LOGGER_CONFIG,
    CM_LOGGER_GRAPH,
    CM_LOGGER_JOBS,
    CM_LOGGER_MATERIALS,
    CM_LOGGER_PICTURES,
    CM_LOGGER_RENDERING,
    CM_LOGGER_ROUTING,
    CM_LOGGER_SCANNING,
    CM_LOGGER_SCENE,
    CM_LOGGER_TEMPLATES,
    CM_LOGGER_TEXTURES,
    CM_LOGGER_UPLOAD,
    CM_LOGGER_WEBASSEMBLY,
    CM_LOGGER_WORKERS,
} from "@app/common/services/logging/logger.tokens"

/**
 * Providers for all domain-specific loggers.
 * Include this in your module's providers array to make loggers injectable.
 */
export const LOGGING_PROVIDERS: Provider[] = [
    {
        provide: CM_LOGGER_API,
        useFactory: (factory: LoggerFactory) => factory.getLogger("api"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_APP,
        useFactory: (factory: LoggerFactory) => factory.getLogger("app"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_AR,
        useFactory: (factory: LoggerFactory) => factory.getLogger("ar"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_AUTH,
        useFactory: (factory: LoggerFactory) => factory.getLogger("auth"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_ROUTING,
        useFactory: (factory: LoggerFactory) => factory.getLogger("routing"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_RENDERING,
        useFactory: (factory: LoggerFactory) => factory.getLogger("rendering"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_WORKERS,
        useFactory: (factory: LoggerFactory) => factory.getLogger("workers"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_WEBASSEMBLY,
        useFactory: (factory: LoggerFactory) => factory.getLogger("webassembly"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_SCANNING,
        useFactory: (factory: LoggerFactory) => factory.getLogger("scanning"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_SCENE,
        useFactory: (factory: LoggerFactory) => factory.getLogger("scene"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_TEMPLATES,
        useFactory: (factory: LoggerFactory) => factory.getLogger("templates"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_MATERIALS,
        useFactory: (factory: LoggerFactory) => factory.getLogger("materials"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_PICTURES,
        useFactory: (factory: LoggerFactory) => factory.getLogger("pictures"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_TEXTURES,
        useFactory: (factory: LoggerFactory) => factory.getLogger("textures"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_GRAPH,
        useFactory: (factory: LoggerFactory) => factory.getLogger("graph"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_CONFIG,
        useFactory: (factory: LoggerFactory) => factory.getLogger("config"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_UPLOAD,
        useFactory: (factory: LoggerFactory) => factory.getLogger("upload"),
        deps: [LoggerFactory],
    },
    {
        provide: CM_LOGGER_JOBS,
        useFactory: (factory: LoggerFactory) => factory.getLogger("jobs"),
        deps: [LoggerFactory],
    },
]
